import React, { createContext, useCallback, useContext, useState } from 'react';
import apiService from '../services/api.service';

const CardContext = createContext();

export const CardProvider = ({ children }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // cardsFetched: true once the first fetch completes (gates OffersContext initial load)
  // cardsVersion: increments on every successful fetch — triggers offers re-fetch after card add/remove
  const [cardsFetched, setCardsFetched] = useState(false);
  const [cardsVersion, setCardsVersion] = useState(0);

  const fetchCards = useCallback(async (clientId, tenantId) => {
    if (!clientId || !tenantId) {
      console.warn('CardContext: clientId and tenantId are required to fetch cards');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await apiService.get('/api/cards/cardgetall', {
        params: {
          clientid: clientId,
          tenantid: tenantId,
        },
      });

      setCards(response || []);
      setCardsVersion(v => v + 1);
    } catch (err) {
      console.error('Failed to fetch cards:', err);
      setError(err?.response?.data?.message || err?.message || 'Failed to fetch cards');
      setCards([]);
    } finally {
      setLoading(false);
      setCardsFetched(true);
    }
  }, []);

  const clearCards = useCallback(() => {
    setCards([]);
    setError(null);
    setCardsFetched(false);
    setCardsVersion(0);
  }, []);

  const value = {
    cards,
    loading,
    error,
    cardsFetched,
    cardsVersion,
    fetchCards,
    clearCards,
  };

  return <CardContext.Provider value={value}>{children}</CardContext.Provider>;
};

export const useCards = () => {
  const ctx = useContext(CardContext);
  if (!ctx) throw new Error('useCards must be used within CardProvider');
  return ctx;
};
